import React from 'react';
import { EchoInstance } from './EchoInstance';

export const EchoContext = React.createContext(EchoInstance.getEcho());